module.exports = __webpack_public_path__ + "static/media/letter_c.7730f101.m4a";